// eventsRepository.js
// API repository for events-related backend calls
import { DateParser } from '../utils/DateParser';
import { buildApiUrl } from './apiUtils.js';

export const EventsRepository = {
    async fetchEvents(filters = {}) {
        // Build query parameters matching GetEventsRequest.swift structure
        const params = new URLSearchParams();
        
        // Add club parameter
        params.append('club', 'gdynia-padel-club');
        
        // Add date range if provided
        if (filters.from) {
            const fromSeconds = filters.from instanceof Date ? DateParser.dateToSeconds(filters.from) : filters.from;
            params.append('fromDate', fromSeconds.toString());
        }
        
        if (filters.to) {
            const toSeconds = filters.to instanceof Date ? DateParser.dateToSeconds(filters.to) : filters.to;
            params.append('toDate', toSeconds.toString());
        }
        
        // Add name filter if provided
        if (filters.name) {
            params.append('name', filters.name);
        }
        
        // Add type filters if provided
        if (filters.types && filters.types.length > 0) {
            filters.types.forEach(type => {
                params.append('types[]', type);
            });
        }

        const response = await fetch(`${buildApiUrl('/events')}?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'ngrok-skip-browser-warning': '69420'
            }
        });
        if (!response.ok) throw new Error('Network response was not ok: ' + response.statusText);
        return await response.json();
    },

    async fetchEventById(eventId) {
        if (!eventId) {
            throw new Error('Event ID is required');
        }

        const response = await fetch(`${buildApiUrl(`/events/${eventId}`)}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'ngrok-skip-browser-warning': '69420'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Failed to fetch event details: ${response.statusText}`);
        }
        
        return await response.json();
    }
};

export default EventsRepository;
